import type { ProdutoEmbalagem } from '../models/product.models';

export function parseDecimalValue(value: unknown): number {
  if (value === null || value === undefined || value === '') return 0;

  const normalizedValue =
    typeof value === 'string' ? value.trim().replace(',', '.') : value;

  return Number(normalizedValue);
}

export function finiteDecimalValue(value: unknown, fallback = 0): number {
  const parsedValue = parseDecimalValue(value);
  return Number.isFinite(parsedValue) ? parsedValue : fallback;
}

export function packagingFactor(embalagem?: ProdutoEmbalagem): number {
  return embalagem ? Number(embalagem.qtUnit) : 1;
}

export function hasValidPackagingFactor(embalagem?: ProdutoEmbalagem): boolean {
  const factor = packagingFactor(embalagem);
  return Number.isFinite(factor) && factor > 0;
}

export function packagingCartValues(
  unitPrice: number,
  packageQuantity: number,
  embalagem?: ProdutoEmbalagem,
  discount = 0,
) {
  if (!hasValidPackagingFactor(embalagem)) {
    throw new Error('A embalagem não possui um fator de conversão válido.');
  }

  const qtd = packageQuantity;
  const preco = Number((unitPrice * packagingFactor(embalagem)).toFixed(8));
  const normalizedDiscount = finiteDecimalValue(discount);
  const precoComDesconto = preco * (1 - normalizedDiscount / 100);
  return {
    qtd,
    preco,
    precoComDesconto,
    subTotal: Number((precoComDesconto * qtd).toFixed(2)),
  };
}

interface PackagingCartItem {
  id: number;
  unidade?: string;
  embalagemSelecionada?: ProdutoEmbalagem;
}

export function sameCartPackaging(
  first: PackagingCartItem,
  second: PackagingCartItem,
): boolean {
  if (first.id !== second.id || first.unidade !== second.unidade) return false;

  const a = first.embalagemSelecionada;
  const b = second.embalagemSelecionada;
  if (!a || !b) return !a && !b;

  return a.nomeEmbalagem === b.nomeEmbalagem &&
    a.unidadeDeVenda === b.unidadeDeVenda &&
    a.ean === b.ean &&
    packagingFactor(a) === packagingFactor(b);
}
